import { router } from '@inertiajs/react'
import { useEffect } from 'react'
import { loadPostHog } from '@/lib/posthog'

export function MarketingAnalytics() {
  useEffect(() => {
    let cancelled = false
    let stopListening: (() => void) | undefined

    const start = () => {
      void loadPostHog().then((posthog) => {
        if (!posthog || cancelled) return

        posthog.capture('$pageview')
        stopListening = router.on('navigate', () => posthog.capture('$pageview'))
      })
    }

    const idleId = window.requestIdleCallback?.(start, { timeout: 2_000 })
    const timeoutId = idleId === undefined ? window.setTimeout(start, 1_500) : undefined

    return () => {
      cancelled = true
      stopListening?.()
      if (idleId !== undefined) window.cancelIdleCallback?.(idleId)
      if (timeoutId !== undefined) window.clearTimeout(timeoutId)
    }
  }, [])

  return null
}
